(function (angular) {
	'use strict';
	const service = require('../services/pmtAccessService.js');

	angular.module('PinMeTo.services').service('pmtAccessService', [
		'$q',
		'$stateParams',
		'auth',
		function ($q, $stateParams, auth) {
			this.checkPermission = function (requiredPermission, site) {
				site = $stateParams.site || site;
				return auth.getUser(site).then(function (user) {
					return service.checkPermission(user.selectedSite.name, user, requiredPermission);
				});
			};
			this.hasPermission = service.hasPermission;
		}
	]);
})(angular);
